import type { BuildAttachmentIdParams } from './types'

export const buildAttachmentId = ({
  hash,
  url,
  index,
}: BuildAttachmentIdParams) => {
  const segments = [hash, url, index]
    .filter(
      (segment) => segment !== undefined && segment !== null && segment !== ''
    )
    .map(String)

  return segments.join('-') || String(index)
}
